import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b03bfc1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col h-full mx-auto w-auto min-w-full max-w-[1624px] px-6" }
const _hoisted_2 = { class: "max-w-[1624px] h-full w-full mx-auto flex flex-col" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "relative flex flex-col flex-grow mb-6" }

import { computed, inject, onUnmounted } from 'vue';
import UsersTable from '@/views/users/components/users-table.vue';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { IncrediNote, useIncrediDialog } from 'incredi-ui';
import { onBeforeRouteLeave } from 'vue-router';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import { useSettingsPageLinuxQuery, useSettingsPageWindowsQuery } from '@/graphql/codegen/generated/graphql';
import { useOsService } from '@/services/OsService/OsService';
import UsersNavBar from './components/users-nav-bar.vue';
import { IKRightDrawer } from '../Layout/RightDrawer.InjectionKeys';
import { useUsersPage, useUsersPageProvider } from './users.helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'users',
  setup(__props) {

useUsersPageProvider();
const usersPage = useUsersPage();

const rightDrawer = inject(IKRightDrawer);
const coordinatorsService = inject(IKCoordinatorsService);
const osService = useOsService();
const settingsCaller = osService?.isWindows.value ? useSettingsPageWindowsQuery : useSettingsPageLinuxQuery;
const GQL_Settings = settingsCaller(() => ({
  coordinatorId: coordinatorsService?.selectedCoordinator.value || '',
}));

const dialog = useIncrediDialog();
const showOnlyLocalUsersNote = computed(() => GQL_Settings?.result?.value?.ibManagerEntities?.settings?.common?.auth?.enabled);

onUnmounted(() => {
  rightDrawer?.close();
  dialog?.close('addNewUserDialog');
});

onBeforeRouteLeave(async (to, from, next) => {
  if (usersPage?.editUserForm.form.meta.value.dirty) {
    const confirmModal = await usersPage.editUserForm.editUserConfirmationModal();
    if (confirmModal.ok && !confirmModal.formSuccessfullySubmitted) {
      next(false);
      return;
    }
  }
  next();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, { style: {"margin":"0 auto","width":"100%","display":"inline-flex","flex-direction":"column"} }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_unref(showOnlyLocalUsersNote))
            ? (_openBlock(), _createBlock(_unref(IncrediNote), {
                key: 0,
                type: "Information",
                class: "mb-[6px]"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('users.onlyLocalUsersNote')), 1)
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(UsersNavBar),
          _createElementVNode("div", _hoisted_4, [
            (_unref(usersPage)?.usersTable.users.value)
              ? (_openBlock(), _createBlock(UsersTable, {
                  key: 0,
                  class: "users-table w-full absolute",
                  users: _unref(usersPage)?.usersTable.users.value
                }, null, 8, ["users"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})